import moment from "moment";

export function JsonParse(value: any, defaultValue = null) {
  if (!value) {
    return defaultValue;
  }
  try {
    return JSON.parse(value);
  } catch (err) {
    return defaultValue;
  }
}

export const GetLocalStorage = (store: string, key: string) => {
  const item = localStorage.getItem(store);
  if (!item) {
    return null; // or some default value if preferred
  }
  const parsedItem = JsonParse(item);
  return parsedItem?.state?.[key] ?? null;
};

export const SetLocalStorage = (store: string, key: string, value: any) => {
  const item = localStorage.getItem(store);
  let parsedItem = item ? JsonParse(item) : {};

  if (!parsedItem.state) {
    parsedItem.state = {};
  }

  parsedItem.state[key] = value;
  localStorage.setItem(store, JSON.stringify(parsedItem));
};

export function formatTime(time: any): string {
  if (!time) return "-- : -- : --";
  return moment.unix(Number(time)).utcOffset(7).format("DD/MM/YYYY HH:mm");
}
